import React from "react";
import { connect } from "react-redux";

import { showModal, selectOpportunity } from "actions";
import { activeAccountSelector, loadingSelector } from "reducers";
import Table, { choiceCell, currencyCell, dateCell, leadScoreCell } from "components/table";
import IconLink from "../../../components/IconLink";
import { FaEdit, FaTrash } from "react-icons/fa";
import { LEAD_STATUS_CHOICES_MAP } from "../../../constants";
import { LEAD_ROLES_CHOICES, MARKETING_ACTIONS } from "../../leads/constants";
import {
  DELETE_OPPORTUNITY_MODAL,
  DELETE_PRODUCT_MODAL,
  OPPORTUNITY_MODAL,
  TASK_MODAL,
} from "../../../components/modals";
import { TaskTab } from "../../records/constants";

const AccountLeadsTable = ({ ...props }) => {
  if (!props.accountOpportunities) {
    return null;
  }

  const columns = [
    {
      Header: "Action",
      Cell: ({ row }) => {
        return (
          <>
            <IconLink
              Icon={FaEdit}
              iconConfig={{ className: "table--action-icon" }}
              tooltip="View/Edit"
              onClick={() => {
                props.selectOpportunity(row.original.id);
                props.showModal(OPPORTUNITY_MODAL);
              }}
            />
            <IconLink
              Icon={FaTrash}
              iconConfig={{ className: "table--action-icon red" }}
              tooltip="Delete"
              onClick={() => {
                props.selectOpportunity(row.original.id);
                props.showModal(DELETE_OPPORTUNITY_MODAL, { id: row.original.id });
              }}
            />
          </>
        );
      },
    },
    {
      Header: "Insured Names",
      accessor: "insured_names",
    },
    {
      Header: "Insured Ages",
      accessor: "insured_ages",
    },
    {
      Header: "Policy Number",
      accessor: "policy_number",
    },
    {
      Header: "Carrier",
      accessor: "carrier_name",
    },
    {
      Header: "Product Type",
      accessor: "product_type",
    },
    {
      Header: "Insured Lives",
      accessor: "number_of_insured_lives",
    },
    {
      Header: "Face Amount",
      accessor: "face_amount",
      Cell: currencyCell,
    },
  ];

  return (
    <Table
      columns={columns}
      data={props.accountOpportunities}
      initialPageSize={25}
      showPaginationResults={false}
      defaultSort={true}
      defaultPagination={true}
      paginated={true}
      emptyMessage={"No Account Opportunities found"}
      darker={true}
    />
  );
};

const mapStateToProps = state => {
  const accountInfo = activeAccountSelector(state);
  const accountOpportunities = accountInfo.opportunities;

  return {
    accountOpportunities,
    loading: loadingSelector(state),
  };
};

export default connect(mapStateToProps, {
  showModal,
  selectOpportunity,
})(AccountLeadsTable);
